import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ChevronDownIconComponent } from '@kuiper/icons';
import { ProfileDropdownItem, ProfileDropdownSubItem } from '../profile-dropdown.model';
import { ProfileDropdownSubMenuItemComponent } from './profile-dropdown-sub-menu-item/profile-dropdown-sub-menu-item.component';

@Component({
  selector: 'lib-profile-dropdown-sub-menu',
  imports: [ChevronDownIconComponent, TranslocoPipe, ProfileDropdownSubMenuItemComponent],
  templateUrl: './profile-dropdown-sub-menu.component.html',
  styleUrl: './profile-dropdown-sub-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ProfileDropdownSubMenuComponent {
  selectedMenuItem = input.required<ProfileDropdownItem | null>();
  subMenuItems = input<ProfileDropdownSubItem[]>([]);
  selectedSubMenuItem = input<ProfileDropdownSubItem | null>(null);
  action = output<ProfileDropdownSubItem>();

  applyMainMode = output<void>();

  returnToMainMode() {
    this.applyMainMode.emit();
  }

  selectSubMenuItem(subItem: ProfileDropdownSubItem) {
    this.action.emit(subItem);
  }
}
